/** The share of users, 0–100, asked to fill in the Student Progress Reports feedback form. */
export const FEEDBACK_PERCENT = 20;

/**
 * Whether this user is asked to fill in this form. The same user always gets the same answer,
 * raising the percent only adds users, and each form draws its own group.
 */
export function inFeedbackSample(formId: string, userId: string, percent: number): boolean {
  return bucket(`${formId}:${userId}`) < percent;
}

// FNV-1a: a small, stable string hash, spread over 0–99.
function bucket(key: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < key.length; i++) {
    hash ^= key.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0) % 100;
}
